import { ISwAppDashboardApi } from "../../interfaces-and-types";

type TDashboardUrls = { [key in keyof ISwAppDashboardApi]: string };

const rootDashboardUrl = "/dashboard";

export const dashboardUrls: TDashboardUrls = {
  getCustomersSummary: `${rootDashboardUrl}/customers-summary`,
  getCustomersByPeriod: `${rootDashboardUrl}/customers-by-period`,
  getTransactionsSummary: `${rootDashboardUrl}/transactions-summary`,
  getPayoutsSummary: `${rootDashboardUrl}/payouts-summary`,
  getTodaysTransactions: `${rootDashboardUrl}/txs-today`,
  getTransactionsByPeriod: `${rootDashboardUrl}/txs-by-period`,
  getTransactionsByGatewayByPeriod: `${rootDashboardUrl}/txs-by-gateway`,
  // xxxxxx: `${rootDashboardUrl}/xxxxxxxxx`,
  // xxxxxx: `${rootDashboardUrl}/xxxxxxxxx`,
  // xxxxxx: `${rootDashboardUrl}/xxxxxxxxx`,

  // set dashboard preferences
  // saveOnboardingStep1: `${rootDashboardUrl}/step1`,
  // saveOnboardingStep2: `${rootDashboardUrl}/step2`,
};
